// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TableReport.css */

/* Base Styles */
.table-report-container {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
    line-height: 1.5;
    color: #1a1a1a;
  }
  
  /* Card Container */
  .report-card {
    background: white;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    box-shadow: none;
    overflow: hidden;
    margin: 0 auto;
    max-width: 100%;
  }
  
  /* Header Styles */
  .report-header {
    padding-bottom: 10px;
    border-bottom: 1px solid #e5e7eb;
  }
  
  .report-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #111827;
    margin: 0;
  }
  
  /* Filter Section - scoped to report-card to avoid overlapping with other pages */
  .report-card .filter-section {
    padding: 16px 24px;
    background-color: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
  }
  
  .report-card .filter-grid {
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
  
  .report-card .filter-group {
    margin-bottom: 0;
  }
  
  .report-card .filter-label {
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    margin-bottom: 8px;
  }
  
  .report-card .filter-input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 0.875rem;
    transition: border-color 0.2s, box-shadow 0.2s;
  }
  
  .report-card .filter-input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  
  /* Search row: align label/input with filter grid, button with input */
  .report-card .filter-search-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 16px;
    align-items: end;
    margin-top: 16px;
  }
  
  .report-card .filter-search-row .filter-search-group {
    min-width: 0;
  }
  
  .report-card .filter-search-row .filter-search-group .filter-label {
    margin-bottom: 8px;
  }
  
  .report-card .filter-search-row .filter-reset-btn {
    padding: 8px 16px;
    min-height: 40px;
    align-self: end;
  }
  
  /* Table Styles */
  .table-container {
    overflow-x: auto;
    padding: 0 24px;
  }
  
  .data-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.875rem;
    min-width: 800px;
  }
  
  .data-table thead {
    background-color: #f3f4f6;
  }
  
  .data-table th {
    padding: 12px 16px;
    text-align: left;
    font-weight: 600;
    color: #374151;
    /* text-transform: uppercase; */
    font-size: 0.75rem;
    letter-spacing: 0.05em;
    border-bottom: 1px solid #e5e7eb;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .data-table th:hover {
    background-color: #e5e7eb;
  }
  
  .data-table td {
    padding: 12px 16px;
    border-bottom: 1px solid #e5e7eb;
    vertical-align: middle;
  }
  
  .data-table tr:last-child td {
    border-bottom: none;
  }
  
  .data-table tr:hover {
    background-color: #f9fafb;
  }
  
  /* Status Badges */
  .badge {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 9999px;
    font-size: 0.75rem;
    font-weight: 600;
    text-align: center;
  }
  
  .badge-p1 {
    background-color: #fee2e2;
    color: #b91c1c;
  }
  
  .badge-p2 {
    background-color: #ffedd5;
    color: #9a3412;
  }
  
  .badge-p3 {
    background-color: #fef3c7;
    color: #92400e;
  }
  
  .badge-p4 {
    background-color: #dcfce7;
    color: #166534;
  }
  
  .badge-closed {
    background-color: #dcfce7;
    color: #166534;
  }
  
  .badge-in-progress {
    background-color: #dbeafe;
    color: #1e40af;
  }
  
  .badge-open {
    background-color: #e5e7eb;
    color: #374151;
  }
  
  .badge-breached {
    background-color: #fee2e2;
    color: #b91c1c;
  }
  
  .badge-not-breached {
    background-color: #dcfce7;
    color: #166534;
  }
  
  /* Pagination */
  .pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    border-top: 1px solid #e5e7eb;
  }
  
  .pagination-info {
    font-size: 0.875rem;
    color: #6b7280;
  }
  
  .pagination-controls {
    display: flex;
    gap: 8px;
  }
  
  .pagination-button {
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background-color: white;
    color: #374151;
    font-size: 0.875rem;
    cursor: pointer;
    transition: all 0.2s;
  }
  
  .pagination-button:hover:not(:disabled) {
    background-color: #f3f4f6;
  }
  
  .pagination-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .pagination-button.active {
    background-color: #3b82f6;
    color: white;
    border-color: #3b82f6;
  }
  
  .pagination-ellipsis {
    display: flex;
    align-items: center;
    padding: 0 12px;
    color: #6b7280;
  }
  
  /* Responsive Adjustments */
  @media (max-width: 768px) {
    .table-report-container {
      padding: 12px;
    }

    .report-card .filter-grid {
      grid-template-columns: 1fr;
    }
    
    .report-card {
      margin: 0;
      border-radius: 8px;
    }
    
    .report-header, .report-card .filter-section, .table-container, .pagination {
      padding: 12px;
    }
    
    .report-card .filter-search-row {
      grid-template-columns: 1fr;
    }

    .table-report-container .table-container {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    .table-report-container .data-table {
      min-width: 640px;
      font-size: 12px;
    }
    
    .pagination {
      flex-direction: column;
      gap: 12px;
      align-items: stretch;
    }
    
    .pagination-info {
      text-align: center;
    }
    
    .pagination-controls {
      justify-content: center;
    }
  }
  
  /* React Select Customization - scoped under report card */
  .report-card .select__control {
    min-height: 40px !important;
    border-radius: 6px !important;
    border-color: #d1d5db !important;
  }
  
  .report-card .select__control--is-focused {
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 1px #3b82f6 !important;
  }
  
  /* Menu/options may render in portal - keep global for dropdown styling */
  .select__menu {
    border-radius: 6px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
    border: 1px solid #e5e7eb !important;
  }
  
  .select__option--is-focused {
    background-color: #f3f4f6 !important;
  }
  
  .select__option--is-selected {
    background-color: #3b82f6 !important;
  }
  
  /* Date Picker Customization */
  .react-datepicker-wrapper {
    width: 100% !important;
  }
  
  .react-datepicker {
    font-family: 'Inter', sans-serif !important;
    border-radius: 8px !important;
    border-color: #e5e7eb !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  }
  
  .react-datepicker__header {
    background-color: #f9fafb !important;
    border-bottom-color: #e5e7eb !important;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }
  
  .react-datepicker__day--selected {
    background-color: #3b82f6 !important;
  }
  
  .react-datepicker__day:hover {
    background-color: #f3f4f6 !important;
  }


  .view-switcher {
    display: inline-flex;
    background: #f8fafc;
    border-radius: 8px;
    padding: 4px;
    margin-top: 24px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }
  
  .view-button {
    position: relative;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 500;
    color: #64748b;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    border-radius: 6px;
    z-index: 1;
  }
  
  .view-button:hover {
    color: #334155;
  }
  
  .view-button.active {
    color: #2563eb;
    background: white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  
  /* Alternative minimalist version */
  /*
  .view-switcher {
    display: flex;
    border-bottom: 1px solid #e2e8f0;
    margin-bottom: 24px;
  }
  
  .view-button {
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 500;
    color: #64748b;
    background: none;
    border: none;
    cursor: pointer;
    position: relative;
  }
  
  .view-button:hover {
    color: #334155;
  }
  
  .view-button.active {
    color: #2563eb;
  }
  
  .view-button.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: #2563eb;
  }
  */

/* Compact chart layout (no extra gap above chart) */
.table-report-container.tkts-sla-chart-compact {
  padding-top: 0;
}

.tkts-sla-chart-wrapper {
  width: 100%;
  min-height: 0;
}

/* ===== Dark theme overrides (light mode untouched) ===== */
[data-theme="dark"] .table-report-container {
  color: var(--text);
}
[data-theme="dark"] .report-card {
  background: var(--surface);
  border-color: var(--border);
}
[data-theme="dark"] .report-header {
  border-bottom-color: var(--border);
}
[data-theme="dark"] .report-title {
  color: var(--text);
}
[data-theme="dark"] .report-card .filter-section {
  background-color: var(--surface-2);
  border-bottom-color: var(--border);
}
[data-theme="dark"] .report-card .filter-label {
  color: var(--text);
}
[data-theme="dark"] .report-card .filter-input,
[data-theme="dark"] .pagination-button {
  background: var(--surface);
  border-color: var(--border);
  color: var(--text);
}
[data-theme="dark"] .data-table thead {
  background-color: var(--surface-2);
}
[data-theme="dark"] .data-table th {
  color: var(--text);
  border-bottom-color: var(--border);
}
[data-theme="dark"] .data-table th:hover {
  background-color: var(--surface-3);
}
[data-theme="dark"] .data-table td {
  border-bottom-color: var(--border);
  color: var(--text);
}
[data-theme="dark"] .data-table tr:hover {
  background-color: var(--surface-hover);
}
[data-theme="dark"] .pagination {
  border-top-color: var(--border);
}
[data-theme="dark"] .pagination-info,
[data-theme="dark"] .pagination-ellipsis {
  color: var(--text-muted);
}
[data-theme="dark"] .pagination-button:hover:not(:disabled) {
  background-color: var(--surface-hover);
}
[data-theme="dark"] .view-switcher {
  background: var(--surface-2);
}
[data-theme="dark"] .view-button {
  color: var(--text-muted);
}
[data-theme="dark"] .view-button:hover {
  color: var(--text);
}
[data-theme="dark"] .view-button.active {
  color: var(--primary);
  background: var(--surface);
}
[data-theme="dark"] .react-datepicker__header {
  background-color: var(--surface-2) !important;
  border-bottom-color: var(--border) !important;
}
[data-theme="dark"] .react-datepicker__day:hover {
  background-color: var(--surface-hover) !important;
}
[data-theme="dark"] .select__option--is-focused {
  background-color: var(--surface-hover) !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/data/table-report/TableReport.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB,gBAAgB;AAChB;IACI,kHAAkH;IAClH,gBAAgB;IAChB,cAAc;EAChB;;EAEA,mBAAmB;EACnB;IACE,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA,kBAAkB;EAClB;IACE,oBAAoB;IACpB,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;EAEA,iFAAiF;EACjF;IACE,kBAAkB;IAClB,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,SAAS;IACT,4DAA4D;EAC9D;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;EAChD;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA,sEAAsE;EACtE;IACE,aAAa;IACb,0CAA0C;IAC1C,SAAS;IACT,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA,iBAAiB;EACjB;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,+BAA+B;IAC/B,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,kBAAkB;EAClB;IACE,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA,eAAe;EACf;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;EAChB;;EAEA,2BAA2B;EAC3B;IACE;MACE,aAAa;IACf;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,SAAS;MACT,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,gBAAgB;MAChB,iCAAiC;IACnC;;IAEA;MACE,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,sBAAsB;MACtB,SAAS;MACT,oBAAoB;IACtB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,uBAAuB;IACzB;EACF;;EAEA,0DAA0D;EAC1D;IACE,2BAA2B;IAC3B,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;IAChC,wCAAwC;EAC1C;;EAEA,yEAAyE;EACzE;IACE,6BAA6B;IAC7B,oDAAoD;IACpD,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA,8BAA8B;EAC9B;IACE,sBAAsB;EACxB;;EAEA;IACE,2CAA2C;IAC3C,6BAA6B;IAC7B,gCAAgC;IAChC,oDAAoD;EACtD;;EAEA;IACE,oCAAoC;IACpC,uCAAuC;IACvC,sCAAsC;IACtC,uCAAuC;EACzC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;;EAGA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,wCAAwC;EAC1C;;EAEA,mCAAmC;EACnC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmCC;;AAEH,oDAAoD;AACpD;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,+BAA+B;AACjC;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,6CAA6C;EAC7C,6CAA6C;AAC/C;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD","sourcesContent":["/* TableReport.css */\n\n/* Base Styles */\n.table-report-container {\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n    line-height: 1.5;\n    color: #1a1a1a;\n  }\n  \n  /* Card Container */\n  .report-card {\n    background: white;\n    border-radius: 12px;\n    border: 1px solid #e5e7eb;\n    box-shadow: none;\n    overflow: hidden;\n    margin: 0 auto;\n    max-width: 100%;\n  }\n  \n  /* Header Styles */\n  .report-header {\n    padding-bottom: 10px;\n    border-bottom: 1px solid #e5e7eb;\n  }\n  \n  .report-title {\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: #111827;\n    margin: 0;\n  }\n  \n  /* Filter Section - scoped to report-card to avoid overlapping with other pages */\n  .report-card .filter-section {\n    padding: 16px 24px;\n    background-color: #f9fafb;\n    border-bottom: 1px solid #e5e7eb;\n  }\n  \n  .report-card .filter-grid {\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  }\n  \n  .report-card .filter-group {\n    margin-bottom: 0;\n  }\n  \n  .report-card .filter-label {\n    display: block;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #374151;\n    margin-bottom: 8px;\n  }\n  \n  .report-card .filter-input {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    font-size: 0.875rem;\n    transition: border-color 0.2s, box-shadow 0.2s;\n  }\n  \n  .report-card .filter-input:focus {\n    outline: none;\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  }\n  \n  /* Search row: align label/input with filter grid, button with input */\n  .report-card .filter-search-row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: 16px;\n    align-items: end;\n    margin-top: 16px;\n  }\n  \n  .report-card .filter-search-row .filter-search-group {\n    min-width: 0;\n  }\n  \n  .report-card .filter-search-row .filter-search-group .filter-label {\n    margin-bottom: 8px;\n  }\n  \n  .report-card .filter-search-row .filter-reset-btn {\n    padding: 8px 16px;\n    min-height: 40px;\n    align-self: end;\n  }\n  \n  /* Table Styles */\n  .table-container {\n    overflow-x: auto;\n    padding: 0 24px;\n  }\n  \n  .data-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.875rem;\n    min-width: 800px;\n  }\n  \n  .data-table thead {\n    background-color: #f3f4f6;\n  }\n  \n  .data-table th {\n    padding: 12px 16px;\n    text-align: left;\n    font-weight: 600;\n    color: #374151;\n    /* text-transform: uppercase; */\n    font-size: 0.75rem;\n    letter-spacing: 0.05em;\n    border-bottom: 1px solid #e5e7eb;\n    cursor: pointer;\n    user-select: none;\n  }\n  \n  .data-table th:hover {\n    background-color: #e5e7eb;\n  }\n  \n  .data-table td {\n    padding: 12px 16px;\n    border-bottom: 1px solid #e5e7eb;\n    vertical-align: middle;\n  }\n  \n  .data-table tr:last-child td {\n    border-bottom: none;\n  }\n  \n  .data-table tr:hover {\n    background-color: #f9fafb;\n  }\n  \n  /* Status Badges */\n  .badge {\n    display: inline-block;\n    padding: 4px 8px;\n    border-radius: 9999px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-align: center;\n  }\n  \n  .badge-p1 {\n    background-color: #fee2e2;\n    color: #b91c1c;\n  }\n  \n  .badge-p2 {\n    background-color: #ffedd5;\n    color: #9a3412;\n  }\n  \n  .badge-p3 {\n    background-color: #fef3c7;\n    color: #92400e;\n  }\n  \n  .badge-p4 {\n    background-color: #dcfce7;\n    color: #166534;\n  }\n  \n  .badge-closed {\n    background-color: #dcfce7;\n    color: #166534;\n  }\n  \n  .badge-in-progress {\n    background-color: #dbeafe;\n    color: #1e40af;\n  }\n  \n  .badge-open {\n    background-color: #e5e7eb;\n    color: #374151;\n  }\n  \n  .badge-breached {\n    background-color: #fee2e2;\n    color: #b91c1c;\n  }\n  \n  .badge-not-breached {\n    background-color: #dcfce7;\n    color: #166534;\n  }\n  \n  /* Pagination */\n  .pagination {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px 24px;\n    border-top: 1px solid #e5e7eb;\n  }\n  \n  .pagination-info {\n    font-size: 0.875rem;\n    color: #6b7280;\n  }\n  \n  .pagination-controls {\n    display: flex;\n    gap: 8px;\n  }\n  \n  .pagination-button {\n    padding: 8px 12px;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    background-color: white;\n    color: #374151;\n    font-size: 0.875rem;\n    cursor: pointer;\n    transition: all 0.2s;\n  }\n  \n  .pagination-button:hover:not(:disabled) {\n    background-color: #f3f4f6;\n  }\n  \n  .pagination-button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n  \n  .pagination-button.active {\n    background-color: #3b82f6;\n    color: white;\n    border-color: #3b82f6;\n  }\n  \n  .pagination-ellipsis {\n    display: flex;\n    align-items: center;\n    padding: 0 12px;\n    color: #6b7280;\n  }\n  \n  /* Responsive Adjustments */\n  @media (max-width: 768px) {\n    .table-report-container {\n      padding: 12px;\n    }\n\n    .report-card .filter-grid {\n      grid-template-columns: 1fr;\n    }\n    \n    .report-card {\n      margin: 0;\n      border-radius: 8px;\n    }\n    \n    .report-header, .report-card .filter-section, .table-container, .pagination {\n      padding: 12px;\n    }\n    \n    .report-card .filter-search-row {\n      grid-template-columns: 1fr;\n    }\n\n    .table-report-container .table-container {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n\n    .table-report-container .data-table {\n      min-width: 640px;\n      font-size: 12px;\n    }\n    \n    .pagination {\n      flex-direction: column;\n      gap: 12px;\n      align-items: stretch;\n    }\n    \n    .pagination-info {\n      text-align: center;\n    }\n    \n    .pagination-controls {\n      justify-content: center;\n    }\n  }\n  \n  /* React Select Customization - scoped under report card */\n  .report-card .select__control {\n    min-height: 40px !important;\n    border-radius: 6px !important;\n    border-color: #d1d5db !important;\n  }\n  \n  .report-card .select__control--is-focused {\n    border-color: #3b82f6 !important;\n    box-shadow: 0 0 0 1px #3b82f6 !important;\n  }\n  \n  /* Menu/options may render in portal - keep global for dropdown styling */\n  .select__menu {\n    border-radius: 6px !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;\n    border: 1px solid #e5e7eb !important;\n  }\n  \n  .select__option--is-focused {\n    background-color: #f3f4f6 !important;\n  }\n  \n  .select__option--is-selected {\n    background-color: #3b82f6 !important;\n  }\n  \n  /* Date Picker Customization */\n  .react-datepicker-wrapper {\n    width: 100% !important;\n  }\n  \n  .react-datepicker {\n    font-family: 'Inter', sans-serif !important;\n    border-radius: 8px !important;\n    border-color: #e5e7eb !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;\n  }\n  \n  .react-datepicker__header {\n    background-color: #f9fafb !important;\n    border-bottom-color: #e5e7eb !important;\n    border-top-left-radius: 8px !important;\n    border-top-right-radius: 8px !important;\n  }\n  \n  .react-datepicker__day--selected {\n    background-color: #3b82f6 !important;\n  }\n  \n  .react-datepicker__day:hover {\n    background-color: #f3f4f6 !important;\n  }\n\n\n  .view-switcher {\n    display: inline-flex;\n    background: #f8fafc;\n    border-radius: 8px;\n    padding: 4px;\n    margin-top: 24px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  }\n  \n  .view-button {\n    position: relative;\n    padding: 8px 16px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #64748b;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border-radius: 6px;\n    z-index: 1;\n  }\n  \n  .view-button:hover {\n    color: #334155;\n  }\n  \n  .view-button.active {\n    color: #2563eb;\n    background: white;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  }\n  \n  /* Alternative minimalist version */\n  /*\n  .view-switcher {\n    display: flex;\n    border-bottom: 1px solid #e2e8f0;\n    margin-bottom: 24px;\n  }\n  \n  .view-button {\n    padding: 12px 24px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #64748b;\n    background: none;\n    border: none;\n    cursor: pointer;\n    position: relative;\n  }\n  \n  .view-button:hover {\n    color: #334155;\n  }\n  \n  .view-button.active {\n    color: #2563eb;\n  }\n  \n  .view-button.active::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background: #2563eb;\n  }\n  */\n\n/* Compact chart layout (no extra gap above chart) */\n.table-report-container.tkts-sla-chart-compact {\n  padding-top: 0;\n}\n\n.tkts-sla-chart-wrapper {\n  width: 100%;\n  min-height: 0;\n}\n\n/* ===== Dark theme overrides (light mode untouched) ===== */\n[data-theme=\"dark\"] .table-report-container {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .report-card {\n  background: var(--surface);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .report-header {\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .report-title {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .report-card .filter-section {\n  background-color: var(--surface-2);\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .report-card .filter-label {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .report-card .filter-input,\n[data-theme=\"dark\"] .pagination-button {\n  background: var(--surface);\n  border-color: var(--border);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .data-table thead {\n  background-color: var(--surface-2);\n}\n[data-theme=\"dark\"] .data-table th {\n  color: var(--text);\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .data-table th:hover {\n  background-color: var(--surface-3);\n}\n[data-theme=\"dark\"] .data-table td {\n  border-bottom-color: var(--border);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .data-table tr:hover {\n  background-color: var(--surface-hover);\n}\n[data-theme=\"dark\"] .pagination {\n  border-top-color: var(--border);\n}\n[data-theme=\"dark\"] .pagination-info,\n[data-theme=\"dark\"] .pagination-ellipsis {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .pagination-button:hover:not(:disabled) {\n  background-color: var(--surface-hover);\n}\n[data-theme=\"dark\"] .view-switcher {\n  background: var(--surface-2);\n}\n[data-theme=\"dark\"] .view-button {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .view-button:hover {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .view-button.active {\n  color: var(--primary);\n  background: var(--surface);\n}\n[data-theme=\"dark\"] .react-datepicker__header {\n  background-color: var(--surface-2) !important;\n  border-bottom-color: var(--border) !important;\n}\n[data-theme=\"dark\"] .react-datepicker__day:hover {\n  background-color: var(--surface-hover) !important;\n}\n[data-theme=\"dark\"] .select__option--is-focused {\n  background-color: var(--surface-hover) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
